import React from "react";

function CountriesFlagsComponent(params) {
  const importAll = (require) =>
    require.keys().reduce((acc, next) => {
      acc[next.replace("./", "")] = require(next);
      return acc;
    }, {});

  const images = importAll(require.context("../images/flags/", false, /\.(svg)$/));

  const key = params.countryCode + ".svg";
  const entry = images[key];
  const url = entry && entry.default ? entry.default : entry;

  if (!url) {
    return null;
  }

  return (
    <>
      <img style={params.style} alt={params.alt} src={url} />
    </>
  );
}

export default CountriesFlagsComponent;

